<div class="container mt-5">
	<h1 class="text-center mb-5">{{ "iterlex.welcome" | translate }}</h1>
	<div class="row">
		@for (authority of authorities; track authority.id) {
			<div class="col-sm-4">
				<div class="card-wrapper card-space">
					<it-card>
						<h2 class="it-card-title h5">
							{{
								authority.label[
									"iterlex.currentLanguage" | translate
								]
							}}
						</h2>
						<div class="it-card-body d-flex flex-column">
							@if (authority.children.length === 0) {
								<a
									routerLink="/dossiers"
									[queryParams]="{ authority: authority.id }"
									[attr.aria-label]="
										('it.general.show' | translate) +
										' ' +
										authority.label[
											'iterlex.currentLanguage'
												| translate
										]
									"
								>
									<span class="text">{{
										"it.general.show" | translate
									}}</span>
									<it-icon name="arrow-right"></it-icon>
								</a>
							}
							@for (child of authority.children; track child.id) {
								<a
									routerLink="/dossiers"
									[queryParams]="{ authority: child.id }"
								>
									<span class="text">
										{{
											child.label[
												"iterlex.currentLanguage"
													| translate
											]
										}}
									</span>
									<it-icon name="arrow-right"></it-icon>
								</a>
							}
						</div>
					</it-card>
				</div>
			</div>
		}
	</div>
</div>
